import React from "react";

export const TeamRoles: React.FC = () => {
  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <h1 className="text-3xl font-bold">Team Roles</h1>
    </div>
  );
};
